module.exports = __webpack_public_path__ + "img/hot_icon.88823c99.png";